// MessagePanel.js
import { connect } from 'react-redux';

import { FEATURE_STORY_VOLUME_BUTTON } from '../RemoteConfigKeys.js';

import MessagePanel from '../component/MessagePanel.jsx';

import fetchMessageRating from '../action/fetchMessageRating.js';
import fetchMessageDetail from '../action/fetchMessageDetail.js';
import fetchDrmLicenseAvailability from '../action/fetchDrmLicenseAvailability.js';
import fetchUser from '../action/fetchUser.js';
import setMessageExpanded from '../action/setMessageExpanded.js';
import submitMessageRating from '../action/submitMessageRating.js';
import login from '../action/login.js';
import getUserData from '../selector/getUserData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getMessageData from '../selector/getMessageData.js';
import getMeData from '../selector/getMeData.js';
import getOperationData from '../selector/getOperationData.js';
import getMessageList from '../selector/getMessageList.js';
import getAssetData from '../selector/getAssetData.js';
import getShareTemplates from '../selector/getShareTemplates.js';
import { getKeySystem } from '../resource/getDrmInfo.js';
import { ProfileListType } from '../resource/profileConstants.js';
import { breakpoint } from '../style/variables.js';
import { ShareType } from '../hook/useShortShareLink.js';

const mapStateToProps = (state, { id }) => {
  const unlockPrice = getMessageData(state, id, 'unlockPrice');
  const listType = getOperationData(state, ['usingList', 'messages'], 'type');
  const senderId = getMessageData(state, id, 'senderId');
  const assetIds = getMessageData(state, id, 'assetIds');
  const assetId = assetIds?.[0];
  const deviceWidth = getOperationData(state, ['device'], 'width');
  const isOnDesktop = deviceWidth > breakpoint.mobile;
  const meId = getMeData(state, 'id');

  return {
    isVolumeButtonEnabled:
      getRemoteConfigData(state, FEATURE_STORY_VOLUME_BUTTON) === 1,
    isInputFocused: getOperationData(state, ['message', id], 'isInputFocused'),
    isAuthed: !!meId,
    unlockPrice,
    isUserActive: true,
    isPublished: getMessageData(state, id, 'isPublished'),
    isUnlocked: getMessageData(state, id, 'canViewMedia'),
    isFree: unlockPrice === 0,
    isOnDesktop,
    listType,
    userId: senderId,
    username: getUserData(state, senderId, 'username'),
    mediaType: assetId
      ? getAssetData(state, [assetId], 'contentType')
      : getMessageData(state, id, 'mediaType'),
    expandedField: getOperationData(state, ['message', id], 'expandedField'),
    outboxCount: getMessageList(
      state,
      'outbox',
      ['outbox', ProfileListType.STORY, senderId],
      'totalCount'
    ),
    showOperationsBar: listType !== 'story' && listType !== 'messagePacks',
    showInput:
      listType !== 'story' && // archive story
      listType !== 'messagePacks' &&
      listType !== 'chat',
    ratedAs: getMessageData(state, id, 'ratedAs'),
    shareButtonTemplates: getShareTemplates(state, ShareType.STORY),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    login: () => dispatch(login()),
    submitRating: ({ id, rating }) =>
      dispatch(submitMessageRating({ id, rating })),
    fetchMeRating: id => dispatch(fetchMessageRating({ id })),
    fetchDetail: id => dispatch(fetchMessageDetail({ id })),
    fetchViewScope: id =>
      dispatch(
        fetchDrmLicenseAvailability({
          messageId: id,
          keySystem: getKeySystem(),
        })
      ),
    fetchUser: userId => dispatch(fetchUser({ id: userId })),
    setExpanded: ({ expandedField, messageId }) =>
      dispatch(setMessageExpanded({ expandedField, messageId })),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MessagePanel);
